$giper_bot $mol_book2
	Model? $mol_github_model
		params * temperature 0
		rules <= context <= rules \
			\Ты - Гипер Бот, универсальный интеллектуальный ассистент, помогающий пользователю редактировать текстовый документ.
			\Пользователь присылает тебе запрос в виде JSON строки.
			\Ответ должен быть представлен в виде JSON объекта, соответствующего следующей схеме:
			\	type Response = {
			\		message: string // ответ на вопрос пользователя в свободной форме
			\		files: string[] // ссылки на файлы для скачивания
			\		document: string | null // финальный текст, null если обновление не требуется
			\		confidence: number // степень уверенности в ответе от 0 до 1
			\		digest: string // краткий пересказ всего диалога от начала до конца
			\		title: string // ёмкий лаконичное название всего диалога
			\	}
			\Если пользователь попросил что-то написать или изменить, то это должно быть отражено в document, а не должно дублироваться в message. 
			\Если пользователь что-то спросил, то в message должен быть максимально точный и лаконичный ответ без лишней информации, о которой пользователь не просил.
			\Говоря о пользователе в пересказе (и только в нём) используй эмодзи 🙂 вместо слова "пользователь", а вместо "Гипер Бота" - используй эмозди 🤖.
			\Отвечай всегда на языке с кодом {lang}, если пользователь не попросил иное.
		state <= state /string
			\Далее идёт состояние документа, на который сейчас смотрит пользователь, и к которому относится его последний запрос:
			<= result
	plugins /
		<= Theme $mol_theme_auto
	quote? \
	pages /
		<= Space $giper_web_frame
		<= Dialog $mol_page
			title <= dialog_title? @ \🤖 Giper Bot
			tools /
				<= Reset $mol_button_minor
					hint @ \Reset
					click? <=> reset? null
					sub /
						<= Reset_icon $mol_icon_trash_can_outline
				<= Lights $mol_lights_toggle
			body_content /
				<= Status $mol_status
					status <= communication null
				<= Messages $mol_list
					rows <= messages /
						<= Message*0 $mol_view sub /
							<= Message_text* $mol_text text <= message_text* \
			foot /
				<= Attach $mol_attach
					items? <=> attach? /string
				<= Prompt_text $mol_textarea
					event *
						^
						pointerdown? <=> quote_start? null
						pointerup? <=> quote_end? null
					hint @ \Ask something...
					value? <=> prompt_text? \
					submit? <=> prompt_submit? null
				<= Prompt_submit $mol_button_minor
					hint @ \Send
					click? <=> prompt_submit? 
					sub /
						<= Prompt_submit_icon $mol_icon_send
		<= Result_page*0 $mol_page
			title <= result_title? @ \Result
			tools /
				<= Version $mol_paginator
					value? <=> version? 0
			body /
				<= Result $mol_textarea
					sidebar_showed true
					value? <=> result? \
	placeholders /
		<= Context $mol_page
			title @ \Summary
			tools /
				<= Sources $mol_link_source
					uri \https://github.com/giper-dev/bot/
				<= Donate $mol_link_donate
					uri \https://boosty.to/hyoo
				<= Support $mol_link_support
					uri \https://t.me/giper_web/276
			body /
				- <= Digest_block $mol_labeler
					title @ \Digest
					Content
				<= Digest $mol_text
					text <= digest? \
				- <= Rules_block $mol_labeler
					title @ \Rules
					Content <= Rules $mol_text
						text <=
